import { registerCustomMetadataAdapters } from '@interacta/data-access-community';
import { toAttachmentsList } from '@interacta/data-access-post';
import { Delta2Server } from '@modules/core/helpers/delta/delta-2-server.class';
import { Server2Delta } from '@modules/core/helpers/delta/server-2-delta.class';
import { toPostLink } from '@modules/post/models/post-link/post-link-break-circular.deserialize';
import { toLinkedBy } from '@modules/post/models/post-link/post-link.deserialize';
import { CommunityTreeDeserialize } from '../communities.model';
import { toActivationMetadata } from '../custom-metadata-activation/custom-metadata-activation.deserialize';
import { fromServerCustomFields } from './custom-metadata.serialize';
import {
    getInputFieldValue,
    getServerValue,
    getValidators,
} from './custom-metadata.utils';

/**
 * Wires @interacta/data-access-community to the pieces that still live in
 * the app: delta codec, post-world deserializers and the form
 * half. Must run before anything builds a CustomFields instance — invoked
 * from the shell app initializer.
 */
export function registerShellCustomMetadataAdapters(): void {
    registerCustomMetadataAdapters({
        deltaDecode: (serverValue) =>
            new Server2Delta().process(serverValue as string),
        deltaEncode: (delta, clearIdForMentionTypes) =>
            new Delta2Server().process(delta, clearIdForMentionTypes ?? []),
        toPostLink: (raw) => toPostLink(raw),
        toAttachmentsList: (raw, totalCount) =>
            toAttachmentsList(raw, totalCount, null, null),
        buildInputValue: (serverValue, definition) =>
            getInputFieldValue(serverValue, definition),
        buildValidators: (definition) => getValidators(definition),
        fromServerCustomFields: (customFields, clearIdForMentionTypes) =>
            fromServerCustomFields(customFields, clearIdForMentionTypes ?? []),
        getServerValue: (value, definition) =>
            getServerValue(value, definition),
        toActivationMetadata: (recordValidation, sourceFieldType) =>
            toActivationMetadata(recordValidation, sourceFieldType),
        getDescriptionI18n: (raw) =>
            CommunityTreeDeserialize.getDescriptionI18n(raw),
        toLinkedBy: (raw) => toLinkedBy(raw),
    });
}
